import { call, take, put  }  from 'redux-saga/effects';
import axios                 from 'axios';
import { 
        SET_GROUP_LESSONS,         
        SET_GROUP_LESSONS_LOADER,
        RECORD_ERROR_SAGA
      }                      from '../actions';
import mockData              from '../data/mockData/mockGroupData';
import { SET_ALL_CONTENT }   from 'actions/contentActions';

const getGroupsEndpoint = 'https://www.yisumatica.org.il/flash-upload/js/outsiders/php/get_lesson_list_mygroup.php';

const addOrigin = (arr: { [key: string]: any }) => {
   for ( let i = 0; i < arr.length; i++ ) {
       arr[i].origin = 'teacherContent';
       arr[i].author = ''
   }

   return arr;
}


function* getGroupLessons(): Generator<any,any,any> {
  while(true) {
    try {

       // console.log('GET_GROUP_LESSONS_SAGA')
     

        const userInput = yield take('GET_GROUP_LESSONS_SAGA');

        yield put(SET_GROUP_LESSONS_LOADER())

        const { groupName } = userInput.payload;

        const fail = {
          name:    groupName,
          lessons: []
        }

        if (process.env.NODE_ENV === 'development') {

              const lessons = yield addOrigin(mockData)
            
              const payload = {
                name:    groupName,
                lessons: lessons
              }
            
              if ( groupName === 'צבי' ) {
                yield put(SET_GROUP_LESSONS( payload ))
                yield put(SET_ALL_CONTENT(lessons))
              }
              else {
                yield put(SET_GROUP_LESSONS( fail ))
              }
              
        }


        if (process.env.NODE_ENV === 'production') {

            const groups = yield call( axios.post, getGroupsEndpoint, { mygroup: groupName });

          //  console.log('groups.data    :   ',groups.data)

            if (groups && groups.data && groups.data.length > 0) {

                const lessons = yield addOrigin(groups.data);

                const payload = {
                  name:    groupName,
                  lessons: lessons
                }

                yield put(SET_GROUP_LESSONS( payload ))//
                
                if ( lessons.length > 0 ) {
                  yield put(SET_ALL_CONTENT(lessons))
                }

            }

            else {
              yield put(SET_GROUP_LESSONS(fail))
              console.log("can't get groups")
            }

            
        }
    }
    catch(err) {
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'SET_GROUP_LESSONS_SAGA' }))
      yield put(SET_GROUP_LESSONS({
        name:    '',
        lessons: []
      }))
      console.log('err in getGroups  :  '+err);
    }
    finally {}
  }
}


export default getGroupLessons;






